<template>
<v-card flat >

  <v-card-title class="grey overline darken-4 py-1 white--text" >
    Change appointment type/practitioner
    <v-spacer/>
    <v-btn small icon dark @click="$emit('close')" >
      <v-icon small dark >close</v-icon>
    </v-btn>
  </v-card-title>
  <request-status :request="req" @ok="transferSuccess" />
  <v-divider/>

  <center>
  <v-card-title class="justify-center" >
    Where would you like to move this appointment?
  </v-card-title>

  <practitioner-product-picker
    :practitioner.sync="topractitioner"
    :product.sync="toproduct"
    :location.sync="tolocation" />

  <!-- <pre v-text="product" /> -->

  <v-divider class="mt-2" />
  <div class="grey lighten-4 py-2" >
    <template v-if="product" >
      <strong class="overline ml-2" >Change appointment type:</strong><br/>
      <strong class="overline ml-2" >from:</strong> {{product.title}} with {{appointment.practitioner_name}}<br/>
    </template>
    <div v-if="toproduct && topractitioner" class="subheading" >
      <strong class="overline ml-2" >to:</strong> {{toproduct.title}} with {{topractitioner.full_name}} @ {{tolocation.name}}
    </div>
  </div>
  <v-divider class="mb-2" />

  <v-card-actions >
    <v-btn flat @click="$emit('close')" >Cancel</v-btn>
    <v-spacer/>
    <v-btn @click="save"
      :disabled="!locationId"
      :loading="req.loading" color="primary" >save</v-btn>
  </v-card-actions>
  </center>
  <!-- <pre v-text="payload" class="caption grey lighten-4" /> -->
</v-card>
</template>
<script>
import PractitionerProductPicker from '@/components/pickers/PractitionerProductPicker.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'TransferAppointment',
  components: {PractitionerProductPicker},
  props: {
    appointment: { type: Object, required: true }
  },
  data () {
    return {
      toproduct: {id: null, title: ''},
      topractitioner: {id: null},
      tolocation: {id: null},
      req: {
        resource: 'ag.practitioner.appointments',
        extra: 'actions/bulk_set_product',
        method: 'post'
      }
    }
  },
  computed: {
    ...mapGetters(['products']),
    locationId () { return this.getObjectPath(this.tolocation, 'id') },
    product () {
      if (this.appointment && this.appointment.product) {
        return this.getProductById(this.appointment.product)
      }
      return {}
    },
    toSpaceId () {
      return this.getObjectPath(this.toproduct, 'space')
    },
    payload () {
      return {
        appointments: String(this.appointment.id),
        practitioner: this.topractitioner.id,
        product: this.toproduct.id,
        location: this.tolocation.id,
        space: this.toSpaceId
      }
    }
  },
  methods: {
    save () {
      this.req.data = this.payload
      this.$request('save', this.req)
    },
    getProductById (id) {
      return this.products.find((prod) => {
        return (this.idsAreEqual(prod.id, id))
      })
    },
    transferSuccess () {
      this.$emit('saved', this.req)
      this.$store.dispatch('fetchAppointments')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Index.vue?5c23faa8